"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../atoms/Icon");
var _Table = require("./Table.styled");
var _jsxRuntime = require("react/jsx-runtime");
var TableGroup = function TableGroup(_ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle,
    expanded = _ref.expanded,
    dataCy = _ref['data-cy'];
  var _ref2 = (0, _react.useState)(expanded),
    _ref3 = _slicedToArray(_ref2, 2),
    _expanded = _ref3[0],
    setExpanded = _ref3[1];
  var toggleExpansion = function toggleExpansion() {
    setExpanded(function (prevState) {
      var newValue = !prevState;
      onToggle && onToggle(newValue);
      return newValue;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table.TableGroupHeader, {
    onClick: toggleExpansion,
    "data-cy": dataCy,
    children: [children, _expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronUp',
      size: 'l'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronDown',
      size: 'l'
    })]
  });
};
TableGroup.defaultProps = {};
var _default = exports.default = TableGroup;